/**
 * VIVA HUB API client
 */

const API_BASE = '/api/hub'

async function request(endpoint, options = {}) {
  const response = await fetch(`${API_BASE}${endpoint}`, {
  ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    const error = new Error(data.error || 'Request failed')
    error.status = response.status
    error.data = data
    throw error
  }

  if (data.success === false && data.error) {
    const error = new Error(data.error)
    error.status = response.status
    error.data = data
    throw error
  }

  return data
}

export const hubContactAPI = {
  list: (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return request(`/contact/submissions${query ? `?${query}` : ''}`)
  },
  updateReachedOut: (id, reachedOut) =>
    request(`/contact/submissions/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ reached_out: reachedOut }),
    }),
}

export const hubSupportAPI = {
  submit: (body) =>
    request('/support', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
}

export const hubWhatsAppAPI = {
  list: (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return request(`/whatsapp/messages${query ? `?${query}` : ''}`)
  },
}

export const hubIntakeAPI = {
  list: (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return request(`/intake/submissions${query ? `?${query}` : ''}`)
  },
  updateSaved: (id, savedInSimplePractice) =>
    request(`/intake/submissions/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ saved_in_simple_practice: savedInSimplePractice }),
    }),
}

export const hubCrmAPI = {
  listLeads: (params = {}) => {
    const query = new URLSearchParams(params).toString()
    return request(`/crm/leads${query ? `?${query}` : ''}`)
  },
  createLead: (body) =>
    request('/crm/leads', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  getLead: (id) => request(`/crm/leads/${id}`),
  updateLead: (id, body) =>
    request(`/crm/leads/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  addNote: (id, text) =>
    request(`/crm/leads/${id}/notes`, {
      method: 'POST',
      body: JSON.stringify({ text }),
    }),
  markSpMigrated: (id, spReference) =>
    request(`/crm/leads/${id}/sp-migrated`, {
      method: 'POST',
      body: JSON.stringify({ sp_reference: spReference || undefined }),
    }),
  submitManualIntake: (id, body) =>
    request(`/crm/leads/${id}/intake`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  sendIntakeLink: (id, { language, channels, email, update_status } = {}) =>
    request(`/crm/leads/${id}/send-intake-link`, {
      method: 'POST',
      body: JSON.stringify({
        ...(language != null ? { language } : {}),
        ...(channels?.length ? { channels } : {}),
        ...(email != null ? { email } : {}),
        ...(update_status != null ? { update_status } : {}),
      }),
    }),
  sendAssigneeNudge: (id, body) =>
    request(`/crm/leads/${id}/nudge`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  callLead: (id) =>
    request(`/crm/leads/${id}/call`, {
      method: 'POST',
      body: JSON.stringify({}),
    }),
  getSettings: () => request('/crm/settings'),
  updateSettings: (body) =>
    request('/crm/settings', {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  testNotificationEmail: ({ template, send = false, lead_id } = {}) =>
    request('/crm/settings/test-email', {
      method: 'POST',
      body: JSON.stringify({ template, send, ...(lead_id != null ? { lead_id } : {}) }),
    }),
  testClientFollowup: ({
    variant,
    channel,
    language,
    send = false,
    lead_id,
    test_phone,
    test_email,
  } = {}) =>
    request('/crm/settings/test-followup', {
      method: 'POST',
      body: JSON.stringify({
        variant: variant || 'contacted',
        channel: channel || 'email',
        language: language || 'en',
        send,
        ...(lead_id != null ? { lead_id } : {}),
        ...(test_phone?.trim() ? { test_phone: test_phone.trim() } : {}),
        ...(test_email?.trim() ? { test_email: test_email.trim() } : {}),
      }),
    }),
}
